import React from 'react';
import Image from 'next/image';
import { useRouter } from 'next/router';

import { Button } from '@/ui/index';

import styles from './SwapBanner.module.scss';

const SwapBanner = ({ data }) => {
  const router = useRouter();
  return (
    <section
      className='wrapper swap_wrapper'
      itemScope
      itemType='https://schema.org/Advertisement'
    >
      <div className={styles.swap_banner_wrap}>
        <div className={styles.left_side}>
          <Image
            src={data?.icon}
            alt={data?.title}
            title={data?.title}
            loading='lazy'
            width={40}
            height={40}
          />
          <p className={styles.description}>{data?.title}</p>
        </div>
        <Button
          onClick={() => {
            router.push('esim/checkout?id=swap');
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'changeesim',
            });
          }}
          className={styles.button}
          variant={'transparent'}
        >
          {data?.button_text}
        </Button>
      </div>
    </section>
  );
};

export default SwapBanner;
